<div bsModal
     #cancelAllocationModal="bs-modal"
     class="modal fade"
     tabindex="-1"
     role="dialog"
     [config]="{backdrop: 'static'}">
    <div class="modal-dialog modal-lg" style="max-width: 350px;">
        <div class="modal-content" *ngIf="step === 1">
            <div class="modal-header no-border">
                <b>{{ l('AllocationCancelTitle')}}</b>
            </div>
            <div class="modal-body no-border">
                <p class="cancel-description">{{ l('AllocationCancelModalText')}}</p>
                <div class="mt-5">
                    <mat-slide-toggle
                        [(ngModel)]="override"
                        [color]="'primary'"
                        [labelPosition]="'before'">
                        {{ l('OverrideConditionsInNew')}}
                    </mat-slide-toggle>
                </div>
            </div>

            <div class="modal-footer no-border">
                <button [disabled]="saving"
                        type="button"
                        class="btn cancel"
                        (click)="close()">
                    {{l("IveChangedMyMind")}}
                </button>

                <button (click)="step = 2"
                        class="btn btn-primary"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')">
                    <span>
                      {{l("Yes")}}
                    </span>
                </button>
            </div>
        </div>

        <div class="modal-content" *ngIf="step === 2">
            <div class="modal-header no-border">
                <b>{{ l('AllocationCancelReasonTitle')}}</b>
            </div>
            <div class="modal-body no-border">
                   <textarea class="reject-reason"
                             [(ngModel)]="cancelReason"></textarea>
            </div>

            <div class="modal-footer no-border">
                <button [disabled]="saving"
                        type="button"
                        class="btn cancel"
                        (click)="close()">
                    {{l("IveChangedMyMind")}}
                </button>

                <button (click)="cancelAllocation()"
                        class="btn btn-primary"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')">
                    <span>
                      {{l("Yes")}}
                    </span>
                </button>
            </div>

        </div>
    </div>

</div>
